import React, { useEffect } from "react";
import { LogoutLink, ProfileLink } from "../../routes";

import MenuItem from "pages/private/Layout/Menu/MenuItem";
import { useNavigate } from "react-router-dom";
import { AccountCircle, Close as CloseIcon } from "@mui/icons-material";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
  AppBar as MuiAppBar,
} from "@mui/material";
import LanguageSwitcher from "pages/translations/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { getCurrentUserData } from "Application/User/UserService";
import { Logout } from "Application/User/LoginService";
import { getUrl, USER_DETAIL } from "Infrastructure/config/routesConfig";

export default function Header(props: any) {
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  useEffect(() => {
    if (!getCurrentUserData().isCreditorValidated()) {
      navigate(getUrl(USER_DETAIL, { id: "my" }));
    }
  }, []);
  const mobileStyle = isMobile
    ? {
        paddingLeft: theme.mixins.toolbar.minHeight + "px",
      }
    : {};
  return (
    <MuiAppBar
      position="sticky"
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        ...mobileStyle,
      }}
    >
      <Toolbar>
        <Typography
          variant="h5"
          sx={{ textSizeAdjust: "10%", fontWeight: "bold" }}
        >
          {!isMobile && t("welcome")}{" "}
          <span style={{ color: "white" }}>MyCareFlex</span>
        </Typography>
      </Toolbar>

      {isMobile ? <MobileHeaderLinks /> : <HeaderLinks />}
    </MuiAppBar>
  );
}

function HeaderLinks() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginRight: 2,
      }}
    >
      <Box
        sx={{
          marginRight: 2,
        }}
      >
        <LanguageSwitcher />
      </Box>
      <Links />
    </Box>
  );
}

function MobileHeaderLinks() {
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const theme = useTheme();

  return (
    <>
      {!open ? (
        <IconButton
          id="header-menu"
          onClick={handleDrawerOpen}
          sx={{
            position: "absolute",
            float: "right",
            right: 0,
            backgroundColor: "secondary.main",
            zIndex: 1200,
            borderRadius: 0,
            minHeight: theme.mixins.toolbar.minHeight,
            minWidth: theme.mixins.toolbar.minHeight,
            color: theme.palette.primary.contrastText,
          }}
        >
          <AccountCircle />
        </IconButton>
      ) : (
        <Drawer
          variant="temporary"
          open={open}
          anchor="right"
          PaperProps={{
            sx: {
              backgroundColor: "primary.main",
              color: "white",
            },
          }}
          onClose={handleDrawerClose}
        >
          <Box
            sx={{
              minHeight: theme.mixins.toolbar.minHeight,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: theme.palette.primary.contrastText,
            }}
            onClick={handleDrawerClose}
          >
            <IconButton
              sx={{
                color: theme.palette.primary.contrastText,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <LanguageSwitcher />
            <div>
              <Divider sx={{ borderWidth: "2px" }} />
              <Links onClick={handleDrawerClose} />
            </div>
          </Box>
        </Drawer>
      )}
    </>
  );
}

function Links({ onClick }: any) {
  const currentUser = getCurrentUserData();

  function handleClick(e: any) {
    if (onClick) {
      onClick(e);
    }
  }

  const profileLabel = currentUser.isUserInternal()
    ? currentUser.userData.email
    : currentUser.userData.profile.firstName +
      " " +
      currentUser.userData.profile.lastName;

  const profileElement = {
    path: ProfileLink.path,
    key: ProfileLink.key,
    overrideLabel: profileLabel,
    icon: ProfileLink.icon,
  };

  return (
    <>
      <MenuItem
        element={LogoutLink}
        open={true}
        onClick={(e: any) => {
          e.preventDefault();
          handleClick(e);
          Logout();
        }}
      />
      <MenuItem
        url={getUrl(USER_DETAIL, { id: "my" })}
        element={profileElement}
        open={true}
        onClick={handleClick}
      />
    </>
  );
}
